@if (userLoggedIn) {
<div class="loader-overlay">
  <div class="loader-container-wrapper">
    <div class="loader-container">
      <div class="block"></div>
      <div class="block"></div>
      <div class="block"></div>
      <div class="block"></div>
    </div>
    <div class="loader-text">Loading...</div>
  </div>
</div>
}
@else {

<div class="marketing-page-container" [ngClass]="{ mobileLayout: isMobile }">
  <!-- Header (outside smooth-content to stay truly fixed) -->
  <header class="site-header">
    <div class="header-container container">
      <div class="header-inner">
        <div class="header-brand">{{ "HEADER_TITLE" | translate }}</div>
        <div class="header-actions">
          <button (click)="onSignIn()" class="sign-in-btn">
            {{ "HEADER_BTN_SIGNIN" | translate }}
          </button>
        </div>
      </div>
    </div>
  </header>

  <ng-container *ngIf="isMobile; else desktopSmoothLayout">
    <ng-container *ngTemplateOutlet="marketingContent"></ng-container>
  </ng-container>

  <ng-template #desktopSmoothLayout>
    <div id="smooth-wrapper">
      <div id="smooth-content">
        <ng-container *ngTemplateOutlet="marketingContent"></ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template #marketingContent>
    <!-- Page wrapper -->
    <div class="page-wrapper">
        <div class="page-bg"></div>

        <!-- Hero Section -->
        <div class="hero-section">
          <div threeGradientMap [imageUrl]="heroImageUrl" class="hero-canvas"></div>
          <div class="hero-overlay"></div>
          <div class="hero-fade"></div>
          <div class="hero-inner">
            <div class="container">
              <div class="hero-content">
                <h1 class="hero-title">{{ 'HERO_TITLE' | translate }}</h1>
                <p class="hero-subtitle">{{ 'HERO_SUBTITLE' | translate }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Video Demo Section -->
        <section id="demo" class="video-section">
          <div class="container">
            <div class="video-inner">
              <div class="section-header">
                <h2 class="video-section-title">{{ 'VIDEO_TITLE' | translate }}</h2>
                <p class="video-section-subtitle">{{ 'VIDEO_SUBTITLE' | translate }}</p>
              </div>

            </div>
            <div class="video-container" #videoContainer>
              <div class="video-aspect">
                <iframe [src]="videoUrl" class="video-iframe" allowfullscreen
                  allow="accelerometer;clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  title="PULSE Demo Video"></iframe>
              </div>
            </div>
          </div>
        </section>

        <!-- Technology Section -->
        <section class="tech-section">
          <div class="tech-bg-overlay"></div>
          <div class="container">
            <div class="tech-inner">
              <div class="section-header">
                <h2 class="pulse-do-title">{{ 'ABOUT_TITLE' | translate }}</h2>
              </div>
              <div class="tech-grid">
                <div webglGradient class="tech-card">
                  <div class="tech-card-bg"></div>
                  <div class="tech-card-content">
                    <h2 class="tech-card-title">{{ 'TECH_CARD1_TITLE' | translate }}</h2>
                    <p class="tech-card-desc">{{ 'TECH_CARD1_DESC' | translate }}</p>
                  </div>
                </div>
                <div webglGradient class="tech-card">
                  <div class="tech-card-bg"></div>
                  <div class="tech-card-content">
                    <h3 class="tech-card-title">{{ 'TECH_CARD2_TITLE_LINE1' | translate }} <br/> {{ 'TECH_CARD2_TITLE_LINE2' | translate }}   </h3>
                    <p class="tech-card-desc">{{ 'TECH_CARD2_DESC' | translate }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Why PULSE Section -->
        <section id="about" class="about-section">
          <div class="container">
            <div class="about-inner">
              <div class="section-header">
                <h2 class="about-title">{{ 'TECH_TITLE' | translate }}</h2>
              </div>
              <div class="feature-cards-grid">

                <div webglGradient class="feature-card">
                  <div class="feature-card-bg"></div>
                  <div class="feature-card-img"><img src="/assets/images/card1.png" alt="" /></div>
                  <div class="feature-card-content">
                    <div class="feature-icon">
                      <svg class="feature-icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                      </svg>
                    </div>
                    <h3 class="feature-card-title">{{ 'FEATURE_CARD1_TITLE' | translate }}</h3>
                    <p class="feature-card-desc">{{ 'FEATURE_CARD1_DESC' | translate }}</p>
                  </div>
                </div>

                <div webglGradient class="feature-card">
                  <div class="feature-card-bg"></div>
                  <div class="feature-card-img"><img src="/assets/images/card2.png" alt="" /></div>
                  <div class="feature-card-content">
                    <div class="feature-icon">
                      <svg class="feature-icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                    </div>
                    <h3 class="feature-card-title">{{ 'FEATURE_CARD2_TITLE' | translate }}</h3>
                    <p class="feature-card-desc">{{ 'FEATURE_CARD2_DESC' | translate }}</p>
                  </div>
                </div>

                <div webglGradient class="feature-card">
                  <div class="feature-card-bg"></div>
                  <div class="feature-card-img"><img src="/assets/images/card3.png" alt="" /></div>
                  <div class="feature-card-content">
                    <div class="feature-icon">
                      <svg class="feature-icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                    </div>
                    <h3 class="feature-card-title">{{ 'FEATURE_CARD3_TITLE' | translate }}</h3>
                    <p class="feature-card-desc">{{ 'FEATURE_CARD3_DESC' | translate }}</p>
                  </div>
                </div>

                <div webglGradient class="feature-card">
                  <div class="feature-card-bg"></div>
                  <div class="feature-card-img"><img src="/assets/images/card4.png" alt="" /></div>
                  <div class="feature-card-content">
                    <div class="feature-icon">
                      <svg class="feature-icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                    </div>
                    <h3 class="feature-card-title">{{ 'FEATURE_CARD4_TITLE' | translate }}</h3>
                    <p class="feature-card-desc">{{ 'FEATURE_CARD4_DESC' | translate }}</p>
                  </div>
                </div>

                <div webglGradient class="feature-card">
                  <div class="feature-card-bg"></div>
                  <div class="feature-card-img"><img src="/assets/images/card5.png" alt="" /></div>
                  <div class="feature-card-content">
                    <div class="feature-icon">
                      <svg class="feature-icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <h3 class="feature-card-title">{{ 'FEATURE_CARD5_TITLE' | translate }}</h3>
                    <p class="feature-card-desc">{{ 'FEATURE_CARD5_DESC' | translate }}</p>
                  </div>
                </div>

                <div webglGradient class="feature-card">
                  <div class="feature-card-bg"></div>
                  <div class="feature-card-img"><img src="/assets/images/card6.png" alt="" /></div>
                  <div class="feature-card-content">
                    <div class="feature-icon">
                      <svg class="feature-icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
                      </svg>
                    </div>
                    <h3 class="feature-card-title">{{ 'FEATURE_CARD6_TITLE' | translate }}</h3>
                    <p class="feature-card-desc">{{ 'FEATURE_CARD6_DESC' | translate }}</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>

        <!-- Contact Section -->
        <section id="contact" class="contact-section">
          <div class="container">
            <div class="contact-inner">
              <div class="contact-body">
                <h2 class="contact-title">{{ 'SUPPORT_CONTACT_TITLE' | translate }}</h2>
                <a [href]="'mailto:' + ('CONTACT_EMAIL' | translate)" class="contact-email">
                  {{ 'CONTACT_EMAIL' | translate }}
                </a>
              </div>
            </div>
          </div>
        </section>

    </div><!-- end page-wrapper -->

    <!-- Footer -->
    <footer class="site-footer">
        <div class="footer-container container">
          <div class="footer-inner">

            <div class="footer-top">
              <div class="footer-brand">
                <h2 class="footer-brand-title">CBRE</h2>
              </div>
              <nav class="footer-nav">
                <a href="https://www.cbre.com/about-us" target="_blank" rel="noopener noreferrer"
                  class="footer-nav-link">{{ "FOOTER_NAV_ABOUT" | translate }}</a>
                <a href="https://www.cbre.com/careers" target="_blank" rel="noopener noreferrer"
                  class="footer-nav-link">{{ "FOOTER_NAV_CAREERS" | translate }}</a>
                <a href="https://www.cbre.com/about-us/corporate-responsibility" target="_blank"
                  rel="noopener noreferrer" class="footer-nav-link">{{ "FOOTER_NAV_RESPONSIBILITY" | translate }}</a>
                <a href="https://ir.cbre.com" target="_blank" rel="noopener noreferrer" class="footer-nav-link">{{
                  "FOOTER_NAV_INVESTOR" | translate }}</a>
                <a href="https://www.cbre.com/about-us/newsroom" target="_blank" rel="noopener noreferrer"
                  class="footer-nav-link">{{ "FOOTER_NAV_NEWSROOM" | translate }}</a>
              </nav>
            </div>

            <div class="footer-middle">
              <nav class="footer-legal-links">
                <a href="https://www.cbre.com/about-us/culture-and-history/contact-us" target="_blank" rel="noopener noreferrer"
                  class="footer-legal-link">{{ "FOOTER_LINK_CONTACT" | translate }}</a>
                <a href="https://www.cbre.com/about-us/global-privacy-and-cookie-notice" target="_blank"
                  rel="noopener noreferrer" class="footer-legal-link">{{ "FOOTER_LINK_PRIVACY" | translate }}</a>
                <a href="https://www.cbre.com/about-us/disclaimer-terms-of-use" target="_blank" rel="noopener noreferrer"
                  class="footer-legal-link">{{ "FOOTER_LINK_TERMS" | translate }}</a>
                <a href="https://www.cbre.com/about-us/our-response-to-schrems-ii" target="_blank"
                  rel="noopener noreferrer" class="footer-legal-link">{{ "FOOTER_LINK_SCHEMES" | translate }}</a>
                <a href="https://www.cbre.com/about-us/california-consumer-privacy-policy" target="_blank"
                  rel="noopener noreferrer" class="footer-legal-link">{{ "FOOTER_LINK_CA_PRIVACY" | translate }}</a>
                <a href="https://www.cbre.com/about-us/new-york-disclosure-notices" target="_blank"
                  rel="noopener noreferrer" class="footer-legal-link">{{ "FOOTER_LINK_NY_DISCLOSURE" | translate }}</a>
                <a href="https://cbre.sharepoint.com/" target="_blank" rel="noopener noreferrer"
                  class="footer-legal-link">{{ "FOOTER_LINK_INTRANET" | translate }}</a>
                <a href="https://www.cbre.com/about-us/digital-accessibility" target="_blank"
                  rel="noopener noreferrer" class="footer-legal-link">{{ "FOOTER_LINK_ACCESSIBILITY" | translate }}</a>
              </nav>
              <nav class="footer-social-icons">
                <a href="https://www.facebook.com/cbre" target="_blank" rel="noopener noreferrer"
                  class="footer-social-link">
                  <svg class="footer-social-icon" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a href="https://www.linkedin.com/company/cbre" target="_blank" rel="noopener noreferrer"
                  class="footer-social-link">
                  <svg class="footer-social-icon" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
                <a href="https://twitter.com/cbre" target="_blank" rel="noopener noreferrer" class="footer-social-link">
                  <svg class="footer-social-icon" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
              </nav>
            </div>

            <div class="footer-bottom">
              <p class="footer-copyright">{{ "FOOTER_COPYRIGHT" | translate }}</p>
            </div>

          </div>
        </div>
    </footer>
  </ng-template>
  </div><!-- end marketing-page-container -->


}